module.exports = __webpack_public_path__ + "static/media/S (184).402b2431.jpg";